export const GET_BRANDING_LIST = 'GET_BRANDING_LIST';
export const GET_BRANDING_LIST_SUCCESS = 'GET_BRANDING_LIST_SUCCESS';
export const GET_BRANDING_LIST_FAIL = 'GET_BRANDING_LIST_FAIL';
export const CREATE_BRANDING = 'CREATE_BRANDING';
export const UPDATE_BRANDING = 'UPDATE_BRANDING';
export const DELETE_BRANDING = 'DELETE_BRANDING';
export const DELETE_BRANDING_SUCCESS = 'DELETE_BRANDING_SUCCESS';
export const DELETE_BRANDING_FAIL = 'DELETE_BRANDING_FAIL';

export const getBrandingList = (userType) => ({
  type: GET_BRANDING_LIST,
  userType
});

export const getBrandingListSuccess = (brandings) => ({
  type: GET_BRANDING_LIST_SUCCESS,
  brandings
});

export const getBrandingListFail = () => ({
  type: GET_BRANDING_LIST_FAIL
});

export const deleteBrandingSuccess = (name) => ({
  type: DELETE_BRANDING_SUCCESS,
  name
});

export const deleteBrandingFail = (name) => ({
  type: DELETE_BRANDING_FAIL,
  name
});

export const createBranding = (brandingData) => ({
  type: CREATE_BRANDING,
  brandingData
});

export const updateBranding = (brandingName, brandingData) => ({
  type: UPDATE_BRANDING,
  brandingName,
  brandingData
});

export const deleteBranding = (brandingName) => ({
  type: DELETE_BRANDING,
  brandingName
});
